import otherLayoutEnvs from '../consts/otherLayoutsEnvs'

const getEnvName = (envKey, envLayout, countryLanguage) => {
  let envName

  if (otherLayoutEnvs.includes(envKey)) {
    envName = envKey.replace('REACT_APP', `REACT_APP_${countryLanguage.toUpperCase()}${envLayout}`)
  } else {
    envName = envKey.replace('REACT_APP', `REACT_APP_${countryLanguage.toUpperCase()}`)
  }

  return envName
}

export default getEnvName
